const LEGEND_COLORS_MAP = {
  worried: '#003B69',
  certain: '#99CCDF',
};

const calculateFill = (questionName) => LEGEND_COLORS_MAP[questionName];

export { calculateFill as default, LEGEND_COLORS_MAP as legendMap };
